import { useEffect, useRef } from 'react';

// Custom hook to run an effect only once under certain conditions
export const useEffectOnlyOnce = (callback, dependencies, condition) => {
  const calledOnce = useRef(false);
  useEffect(() => {
    if (calledOnce.current) {
      return;
    }
    if (condition(...dependencies)) {
      callback(...dependencies);
      calledOnce.current = true;
    }
  }, [callback, condition, dependencies]);
};